/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, {useState, useEffect} from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./header/Header"
import "./layout.scss"
import Footer from "./footer"
import { Helmet } from 'react-helmet';
import ThemeContext from '../context/ThemeContext';
import LeftMenu from './menu/LeftMenu';
import DarkModeToggle from "./DarkModeToggle"

const Layout = ({ leftLogo, children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return <>
    <ThemeContext.Consumer>
      {theme => (
        <div className={theme.dark ? 'dark' : 'light'}>
          <div className={`container-fluid pl-0 pr-0 ${theme.menuExpanded ? "expanded": "closed"}`}>
            <Helmet>
              <title>Tonye's Blog</title>
              <script
                src="https://code.jquery.com/jquery-3.3.1.slim.min.js"
                integrity="sha384-q8i/X+965DzO0rT7abK41JStQIAqVgRVzpbzo5smXKp4YfRvH+8abtTE1Pi6jizo"
                crossOrigin="anonymous"
              ></script>
              <script
                src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.7/umd/popper.min.js"
                integrity="sha384-UO2eT0CpHqdSJQ6hJty5KVphtPhzWj9WO1clHTMGa3JDZwrnQq4sF86dIHNDz0W1"
                crossOrigin="anonymous"
              ></script>
              <script
                src="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/js/bootstrap.min.js"
                integrity="sha384-JjSmVgyd0p3pXB1rRibZUAYoIIy6OrQ6VrjIEaFf/nJGzIxFDsf4x0xIM+B07jRM"
                crossOrigin="anonymous"
              ></script>
              <link
                href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
                rel="stylesheet"
                integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"
                crossOrigin="anonymous"
              />
              <link href="https://fonts.googleapis.com/css?family=Changa+One|Comfortaa|Montserrat:400,700|Oswald:400,700|Playfair+Display:400,700&amp;display=swap" rel="stylesheet"></link>
            </Helmet>

            <Header leftLogo={leftLogo} siteTitle={data.site.siteMetadata.title} />
            <div className="jHjsOF">
              <LeftMenu leftLogo={leftLogo} />
            </div>
            <div className="" style={{"position":"relative"}}>
              <main className={`${theme.menuExpanded && "nav-slide no-scroll test"} dxSqMS`}>
                {children}
              </main>
              <footer>
                © {new Date().getFullYear()}, Built with
                {` `}
                <a href="https://www.gatsbyjs.org">Gatsby</a>
              </footer>
            </div>

            <Footer />
            <DarkModeToggle />
            <div className="cursor"><div className="cursor__inner cursor__inner--circle" style={{}}></div> <div className="cursor__inner cursor__inner--dot" style={{}}></div></div>
          </div>
          
        </div>
      )}
    </ThemeContext.Consumer>
  </>
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
